import React from "react";
import ReactDOM from "react-dom/client";

import App from "@/App";
import "@/index.css";

// 🔍 get root container
const container = document.getElementById("root");

// 🛑 safety check (prevents crash confusion)
if (!container) {
  throw new Error(
    "❌ Root element not found. Check public/index.html for <div id='root'></div>"
  );
}

// 🚀 create app root
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);